// 前端报错上报到后端（routes/client-errors.js），管理员在后台概览「前端报错」查看。
// 此前渲染异常只出现在用户自己的控制台——首页白屏是本机走查才发现的。
// 同一页面会话内同一信息只报一次、总数最多 10 条；浏览器插件 / 跨域脚本 / 已知无害的噪音不报。

const RELEASE = process.env.REACT_APP_RELEASE || 'dev';
const API = process.env.REACT_APP_API_URL || '/api';
const MAX_PER_PAGE = 10;
const sent = new Set();

const NOISE = [
  /^Script error\.?$/,               // 跨域脚本，无任何信息
  /ResizeObserver loop/,             // 浏览器无害警告
  /chrome-extension:|moz-extension:|safari-extension:/,
];

export function reportError(kind, error, extra = {}) {
  try {
    if (process.env.NODE_ENV === 'test') return;
    const message = String(error?.message || error || '').slice(0, 500);
    const stack = String(error?.stack || '') + (extra.componentStack ? `\n--- 组件栈 ---${extra.componentStack}` : '');
    if (!message || NOISE.some((re) => re.test(message) || re.test(stack))) return;
    if (sent.has(message) || sent.size >= MAX_PER_PAGE) return;
    sent.add(message);

    const headers = { 'Content-Type': 'application/json' };
    const token = localStorage.getItem('token');
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(`${API}/client-errors`, {
      method: 'POST',
      headers,
      keepalive: true, // 紧接着整页刷新（拆包失败恢复）时也能发出
      body: JSON.stringify({
        kind: error?.name === 'ChunkLoadError' ? 'chunk' : kind,
        message,
        stack: stack.slice(0, 4000),
        page: window.location.pathname,
        release: RELEASE,
      }),
    }).catch(() => {});
  } catch (e) {
    // 上报本身绝不能再抛错
  }
}

export function installGlobalErrorReporting() {
  window.addEventListener('error', (e) => {
    // 图片等资源加载失败也触发 error（无 e.error），不报
    if (e.error || e.message) reportError('error', e.error || e.message);
  });
  window.addEventListener('unhandledrejection', (e) => {
    // 接口请求失败（axios）各页面已自行提示，不当成前端报错
    if (e.reason?.isAxiosError) return;
    reportError('rejection', e.reason);
  });
}
